module.exports = __webpack_public_path__ + "static/media/prev_icon.5bc20e02.svg";